import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef
} from 'react'
import styled from 'styled-components'
import { border, color } from 'styled-system'

import { Loading } from '../Loading'
import { Video } from '../Video'

const HIDE_OVERLAY_CLASSNAME = 'loading__overlay--hide'

export const VideoWrapper = forwardRef(
  ({ autoplay, src, alt, ...props }, ref) => {
    const videoRef = useRef()
    const overlayRef = useRef()
    const durationRef = useRef(1)
    useImperativeHandle(ref, () => videoRef.current)

    useEffect(() => {
      const video = videoRef.current
      if (!video) {
        return
      }

      const onLoadedMetadata = () => {
        durationRef.current = video.duration
      }

      const onCanPlayThrough = () => {
        overlayRef.current.classList.add(HIDE_OVERLAY_CLASSNAME)
      }

      video.addEventListener('loadedmetadata', onLoadedMetadata)
      video.addEventListener('canplaythrough', onCanPlayThrough)

      return () => {
        video.removeEventListener('loadedmetadata', onLoadedMetadata)
        video.removeEventListener('canplaythrough', onCanPlayThrough)
      }
    }, [])

    return (
      <>
        <Video
          type="video/mp4"
          width="100%"
          height="auto"
          autoplay={autoplay}
          ref={r => {
            if (!r) {
              return
            }
            videoRef.current = r.querySelector('video')
          }}
          position={['absolute', 'relative']}
          src={src}
          alt={alt}
          {...props}
        />

        {/* Small little loading flare */}
        <BorderAbsolute
          {...props}
          bg="rgba(0,0,0,0.8)"
          ref={overlayRef}
          className="loading__overlay"
        >
          <Loading />
        </BorderAbsolute>
      </>
    )
  }
)

const BorderAbsolute = styled('div')(
  {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    [`&.${HIDE_OVERLAY_CLASSNAME}`]: {
      display: 'none'
    }
  },
  border,
  color
)
